"use strict";
/**
 * @module Services.TopicViews
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The request of TopicViews CREATE_TOPIC_VIEW service
 */
var NamedTopicViewSpecification = /** @class */ (function () {
    /**
     * Create a new NamedTopicViewSpecification instance
     *
     * @param name           the topic view name
     * @param specification  the topic view specification
     */
    function NamedTopicViewSpecification(name, specification) {
        this.name = name;
        this.specification = specification;
    }
    return NamedTopicViewSpecification;
}());
exports.NamedTopicViewSpecification = NamedTopicViewSpecification;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-views/named-topic-view-specification.js
// module id = 1373
// module chunks = 1